'use strict';

module.exports = function(state) {
	var isPausedBecauseNotInView = state === 'isPausedBecauseNotInView';
	if (this.isCleared) {return;}
	if (!isPausedBecauseNotInView) this.isPaused = true;
	cancelAnimationFrame(this.animation);
};



//////////////////
// WEBPACK FOOTER
// ./~/granim/lib/pause.js
// module id = 22
// module chunks = 0